import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { nuevoSuscriptor } from "../Services/suscriptorServices";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Contact from "../Contact/contact";
//import ReactGA from "react-ga4";

const Suscriptor = () => {
  const [suscriptor, setSuscriptor] = useState({
    nombre: "",
    apellido: "",
    email: "",
    fecha: new Date(),
  });

  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    //ReactGA.send("/suscriptor");
    newCaptcha();
  }, []);

  const [status, setStatus] = useState(null);
  const [button, setButton] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [valido, setValido] = useState(true);

  const newCaptcha = () => {
    setCaptcha(Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000);
  };

  const [msg, setMsg] = useState({
    show: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, show } = msg;

  const form = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (suscriptor.nombre.trim() === "" || suscriptor.apellido.trim() === "")
      return;
    if (form.current.captcha.value == captcha) {
      setButton(true);
      setValido(true);

      setMsg({ show: true, vertical: "top", horizontal: "center" });
      const { data: status } = await nuevoSuscriptor(suscriptor);
      form.current.reset();
      newCaptcha();
      setStatus(status);
      setButton(false);
    } else {
      form.current.captcha.value = "";
      newCaptcha();
      setValido(false);
    }
  };

  //const toSha
  const handleChange = (e) => {
    setSuscriptor({
      ...suscriptor,
      [e.target.name]: e.target.value,
    });
    //console.log([e.target.name], e.target.value);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setMsg({ show: false, vertical: "top", horizontal: "center" });
  };

  return (
    <>
      <Container
        maxWidth="sm xs lg"
        sx={{ backgroundColor: "white" }}
        disableGutters
      >
        <div className="main-bg11">
          <div className="main-title5">
            <h1>
              SUSCRÍBETE
              <AccountCircleIcon
                sx={{ fontSize: 70, color: "#FFF", verticalAlign: "middle" }}
              />
            </h1>
          </div>
        </div>
      </Container>
      <Container sx={{ p: 2, backgroundColor: "white" }}>
        <section>
          {status !== null && (
            <Snackbar
              open={show}
              autoHideDuration={6000}
              onClose={handleClose}
              anchorOrigin={{ vertical, horizontal }}
              key={vertical + horizontal}
            >
              <Alert
                elevation={6}
                severity={status === 0 ? "success" : "warning"}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {status === 0
                  ? "Gracias por suscribirte. Te hemos enviado un email para validar tu cuenta."
                  : "Ya estás suscripto."}
              </Alert>
            </Snackbar>
          )}

          <form onSubmit={handleSubmit} ref={form}>
            <h3 style={{ textAlign: "center" }}>SUSCRIPCIÓN</h3>
            <p>Suscríbete a nuestra comunidad y empieza a formar parte.</p>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  name="nombre"
                  required
                  onChange={(e) => handleChange(e)}
                  variant="standard"
                  label="Nombre"
                  style={{ width: 300 }}
                />
                &nbsp;
                <TextField
                  name="apellido"
                  required
                  onChange={(e) => handleChange(e)}
                  variant="standard"
                  label="Apellido"
                  style={{ width: 300 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  type="email"
                  name="email"
                  required
                  onChange={(e) => handleChange(e)}
                  variant="standard"
                  label="email"
                  style={{ width: 300 }}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  disabled
                  style={{
                    width: "100px",
                    borderColor: "green",
                    backgroundColor: "#ddffd9",
                  }}
                  value={captcha}
                  variant="standard"
                  label="Captcha"
                />
                &nbsp;
                <TextField
                  error={!valido ? true : false}
                  ref={form}
                  name="captcha"
                  required
                  onChange={(e) => handleChange(e)}
                  variant="standard"
                  label="Ingresa el código"
                  style={{ width: 200 }}
                  helperText={!valido && "Código incorrecto"}
                />
              </Grid>
            </Grid>

            <br />
            <Divider />
            <br />
            <Button
              type="submit"
              variant="contained"
              color="secondary"
              disabled={button}
            >
              Suscríbete
            </Button>
          </form>
        </section>
        <br />
        <br />
        <br />
        <br />
      </Container>
      <Contact />
    </>
  );
};

export default Suscriptor;
